import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/credit card.svg` */
export const CreditCardIcon = createTripletGlyphIcon('CreditCardIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.67639 8.6217C4.78494 8.6217 4.87268 8.71042 4.87268 8.81897V9.96936C4.87268 10.0779 4.78494 10.1656 4.67639 10.1656H3.526C3.41745 10.1656 3.32874 10.0779 3.32874 9.96936V8.81897C3.32874 8.71042 3.41745 8.6217 3.526 8.6217H4.67639Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8424 3.12756C13.8822 3.12786 14.725 3.97057 14.7252 5.01038V10.9899C14.7249 12.0296 13.8821 12.8724 12.8424 12.8727H3.15784C2.11803 12.8725 1.27532 12.0296 1.27502 10.9899V5.01038C1.2752 3.9705 2.11796 3.12774 3.15784 3.12756H12.8424ZM2.37463 6.32483V10.9899C2.37493 11.4221 2.72554 11.7729 3.15784 11.7731H12.8424C13.2746 11.7728 13.6253 11.4221 13.6256 10.9899V6.32483H2.37463ZM3.15784 4.22717C2.72547 4.22735 2.37481 4.57801 2.37463 5.01038V5.22522H13.6256V5.01038C13.6254 4.57809 13.2747 4.22747 12.8424 4.22717H3.15784Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.26099 9.69958C5.3831 9.69958 5.48169 9.79915 5.48169 9.92126V11.2152C5.48169 11.3373 5.3831 11.4369 5.26099 11.4369H3.96606C3.84412 11.4367 3.74536 11.3372 3.74536 11.2152V9.92126C3.74536 9.79927 3.84412 9.69979 3.96606 9.69958H5.26099Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4475 3.58728C15.5795 3.58748 16.4973 4.50502 16.4973 5.63708V12.3636C16.497 13.4954 15.5793 14.4133 14.4475 14.4135H3.55298C2.42102 14.4135 1.50353 13.4955 1.50317 12.3636V5.63708C1.50317 4.5049 2.4208 3.58728 3.55298 3.58728H14.4475ZM2.60278 7.08533V12.3636C2.60314 12.888 3.02853 13.3129 3.55298 13.3129H14.4475C14.9718 13.3127 15.3974 12.8879 15.3977 12.3636V7.08533H2.60278ZM3.55298 4.68689C3.02831 4.68689 2.60278 5.11241 2.60278 5.63708V5.8783H15.3977V5.63708C15.3977 5.11254 14.972 4.68709 14.4475 4.68689H3.55298Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.01465 12.9331C7.17747 12.9331 7.30957 13.0652 7.30957 13.228V14.9536C7.30957 15.1164 7.17747 15.2485 7.01465 15.2485H5.28906C5.12624 15.2485 4.99414 15.1164 4.99414 14.9536V13.228C4.99414 13.0652 5.12624 12.9331 5.28906 12.9331H7.01465Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2637 4.76611C20.7821 4.76653 22.0137 5.99759 22.0137 7.51611V16.4839C22.0135 18.0023 20.782 19.2335 19.2637 19.2339H4.7373C3.21864 19.2339 1.98749 18.0025 1.9873 16.4839V7.51611C1.9873 5.99733 3.21852 4.76611 4.7373 4.76611H19.2637ZM3.4873 9.3374V16.4839C3.48749 17.1741 4.04706 17.7339 4.7373 17.7339H19.2637C19.9536 17.7335 20.5135 17.1738 20.5137 16.4839V9.3374H3.4873ZM4.7373 6.26611C4.04695 6.26611 3.4873 6.82576 3.4873 7.51611V7.8374H20.5137V7.51611C20.5137 6.82602 19.9537 6.26653 19.2637 6.26611H4.7373Z"
        fill="currentColor"
      />
    </svg>
  ),
});
